import styled from "styled-components";
import {
  FaBars,
  FaShoppingBag,
  FaSearch,
  FaShoppingCart,
  FaChevronLeft,
} from "react-icons/fa";
import { IBackground, IContainer, IIcon, IInput } from "./IStyled";

export const Div = styled.div<IContainer>`
  flex: ${(props) => (parseInt(`${props.Flex}`) >= 0 ? props.Flex : 1)} ${(props) => (parseInt(`${props.Flex}`) >= 0 ? props.Flex : 1)} ${(props) => (parseInt(`${props.Flex}`) >= 0 ? props.Flex : "100%")};
  flex-direction: ${(props) => (props?.row ? "row" : "column")};
  color: ${(props) => props.TextColor || "#fcfcfc"};
  font-size: ${(props) => props.TextSize || "#fcfcfc"};
  min-height: ${(props) => (props?.Height ? props?.Height : "100%")};
  max-height: ${(props) => (props?.Height ? props?.Height : "100%")};
  height: ${(props) => (props?.Height ? props?.Height : "100%")};
  width: ${(props) => (props?.Width ? props?.Width : "100%")};
  min-width: ${(props) => (props?.Width ? props?.Width : "100%")};
  max-width: ${(props) => (props?.Width ? props?.Width : "100%")};
  justify-content: ${(props) => (props.Content ? props.Content : "none")};
  align-items: ${(props) => (props.Items ? props.Items : "none")};
  flex-wrap: ${(props) => (props.Wrap ? "wrap" : "nowrap")};
  display: flex;
  position: ${(props) => props.Position || 'relative'};;
  overflow: ${(props) => props.overflow || "auto"};
  margin-left: ${(props) => props.Margin?.left || "0px"};
  margin-right: ${(props) => props.Margin?.right || "0px"};
  margin-bottom: ${(props) => props.Margin?.bottom || "0px"};
  margin-top: ${(props) => props.Margin?.top || "0px"};
  padding-left: ${(props) => props.Padding?.left || "0px"};
  padding-right: ${(props) => props.Padding?.right || "0px"};
  padding-bottom: ${(props) => props.Padding?.bottom || "0px"};
  padding-top: ${(props) => props.Padding?.top || "0px"};
  text-overflow: ellipsis;
  text-align: ${(props) => props.TextAlign || "auto"};
  background-color: ${(props) =>
    props?.background ? props?.background : "none"};
  border-radius: ${(props) =>
    props?.borderRadius && props?.borderRadius.all
      ? props?.borderRadius.all
      : "0px"};
  border-top-right-radius: ${(props) =>
    props?.borderRadius && props?.borderRadius.top?.right
      ? props?.borderRadius.top?.right
      : "0px"};
  border-bottom-right-radius: ${(props) =>
    props?.borderRadius && props?.borderRadius.bottom?.right
      ? props?.borderRadius.bottom?.right
      : "0px"};
  border-top-left-radius: ${(props) =>
    props?.borderRadius && props?.borderRadius.top?.left
      ? props?.borderRadius.top?.left
      : "0px"};
  border-bottom-left-radius: ${(props) =>
    props?.borderRadius && props?.borderRadius.bottom?.left
      ? props?.borderRadius.bottom?.left
      : "0px"};
  border-bottom: ${(props) => props?.border?.bottom || "none"};
  border-top: ${(props) => props?.border?.top || "none"};
  border-left: ${(props) => props?.border?.left || "none"};
  border-right: ${(props) => props?.border?.right || "none"};
  border: ${(props) => props?.border?.all || "none"};
  scrollbar-width: none;
  word-wrap: break-word;
  -ms-overflow-style: none;
  &::before {
    content: "${(props) => props.Text || ""}";
    text-overflow: ellipsis;
    word-wrap: break-word;
  }
  &::-webkit-scrollbar {
    display: none;
  }

  &:active {
    opacity: ${(props) => (props.Touch ? 0.6 : 1)};
  }
  &:hover {
    background-color: ${(props) =>
      props.hover?.background ||
      (props?.background ? props?.background : "none")};
    border-bottom: ${(props) => props.hover?.border?.bottom || "none"};
    border-top: ${(props) => props.hover?.border?.top || "none"};
    border-left: ${(props) => props.hover?.border?.left || "none"};
    border-right: ${(props) => props.hover?.border?.right || "none"};
  }
`;

export const IconMenu = styled(FaBars)<IIcon>`
  color: ${(props) => props.color || "#fcfcfc"};
  height: ${(props) => props.size || 30}px;
  width: ${(props) => props.size || 30}px;
`;

export const IconBag = styled(FaShoppingBag)<IIcon>`
  color: ${(props) => props.color || "#fcfcfc"};
  height: ${(props) => props.size || 30}px;
  width: ${(props) => props.size || 30}px;
`;

export const IconSearch = styled(FaSearch)<IIcon>`
  color: ${(props) => props.color || "#fcfcfc"};
  height: ${(props) => props.size || 30}px;
  width: ${(props) => props.size || 30}px;
`;

export const IconFaCart = styled(FaShoppingCart)<IIcon>`
  color: ${(props) => props.color || "#fcfcfc"};
  height: ${(props) => props.size || 30}px;
  width: ${(props) => props.size || 30}px;
`;

export const IconChevronLeft = styled(FaChevronLeft)<IIcon>`
  color: ${(props) => props.color || "#fcfcfc"};
  height: ${(props) => props.size || 30}px;
  width: ${(props) => props.size || 30}px;
`;

export const Input = styled.input.attrs((props: IInput) => ({
  type: props.type || "text",
  placeholder: props.Placeholder?.text || "",
}))<IInput>`
  flex: ${(props) => props.Flex || 1};
  flex-direction: ${(props) => (props?.row ? "row" : "column")};
  margin-left: ${(props) => props.Margin?.left || "0px"};
  margin-right: ${(props) => props.Margin?.right || "0px"};
  margin-bottom: ${(props) => props.Margin?.bottom || "0px"};
  margin-top: ${(props) => props.Margin?.top || "0px"};
  color: ${(props) => props.TextColor || "#fcfcfc"};
  font-size: ${(props) => props.TextSize || "#fcfcfc"};
  min-height: ${(props) => (props?.Height ? props?.Height : "100%")};
  max-height: ${(props) => (props?.Height ? props?.Height : "100%")};
  height: ${(props) => (props?.Height ? props?.Height : "100%")};
  width: ${(props) => (props?.Width ? props?.Width : "100%")};
  min-width: ${(props) => (props?.Width ? props?.Width : "100%")};
  max-width: ${(props) => (props?.Width ? props?.Width : "100%")};
  justify-content: ${(props) => (props.Content ? props.Content : "none")};
  align-items: ${(props) => (props.Items ? props.Items : "none")};
  display: flex;
  text-overflow: ellipsis;
  background-color: ${(props) =>
    props?.background ? props?.background : "none"};
  border-radius: ${(props) =>
    props?.borderRadius && props?.borderRadius.all
      ? props?.borderRadius.all
      : "0px"};
  border-top-right-radius: ${(props) =>
    props?.borderRadius && props?.borderRadius.top?.right
      ? props?.borderRadius.top?.right
      : "0px"};
  border-bottom-right-radius: ${(props) =>
    props?.borderRadius && props?.borderRadius.bottom?.right
      ? props?.borderRadius.bottom?.right
      : "0px"};
  border-top-left-radius: ${(props) =>
    props?.borderRadius && props?.borderRadius.top?.left
      ? props?.borderRadius.top?.left
      : "0px"};
  border-bottom-left-radius: ${(props) =>
    props?.borderRadius && props?.borderRadius.bottom?.left
      ? props?.borderRadius.bottom?.left
      : "0px"};
  padding-left: ${(props) => props.Padding?.left || "0px"};
  padding-right: ${(props) => props.Padding?.right || "0px"};
  padding-bottom: ${(props) => props.Padding?.bottom || "0px"};
  padding-top: ${(props) => props.Padding?.top || "0px"};
  user-select: ${(props) => (props.Touch ? "none" : "select")};
  text-align: ${(props) => props.TextAlign || "auto"};
  cursor: ${(props) => (props.Touch ? "pointer" : "auto")};
  -moz-appearance: textfield;
  &::before {
    content: "${(props) => props.Text || ""}";
  }
  &::placeholder {
    color: ${(props) => props.Placeholder?.color || "black"};
    font-size: ${(props) => props.Placeholder?.size || 14}px;
  }
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const TituloGroup = styled.span`
  font-size: 20px;
  color: rgb(23, 16, 14);
  margin-top: 20px;
  text-align: center;
`;

export const BackGroundModal = styled.div<IBackground>`
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  display: ${(props) => (props.open ? "flex" : "none")};
  justify-content: center;
  align-items: ${(props) => (props.Content ? props.Content : "flex")};
  z-index: 20;
  min-height: 100vh;
  height: 100vh;
  width: 100vw;
  min-width: 100vw;
  top: 0;
  left: 0;
`;
export const BackGroundModalAside = styled.div<IBackground>`
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  overflow: hidden;
  display: ${(props) => (props.open ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  z-index: 15;
  min-height: 100vh;
  height: 100vh;
  width: 100vw;
  min-width: 100vw;
  top: 0;
  left: 0;
`;

export const ButtonBackModal = styled.div`
  position: absolute;
  justify-content: center;
  top: 20px;
  left: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  align-items: center;
  min-height: 40px;
  border: 2px solid rgb(23, 16, 14);
  height: 40px;
  width: 40px;
  min-width: 40px;

  &:active {
    opacity: 0.6;
  }
`;

export const ButtonRemoveProdModal = styled.div`
  position: absolute;
  justify-content: center;
  top: 20px;
  right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  align-items: center;
  min-height: 40px;
  border: 2px solid white;
  height: 40px;
  width: 40px;

  &:active {
    opacity: 0.6;
  }
`;

export const CounterBag = styled.div<IContainer>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  position: absolute;
  color: ${(props) => props.TextColor || "#fcfcfc"};
  margin-left: 33px;
  top: 5px;
  &::before {
    content: "${(props) => props.Text || ""}";
    text-overflow: ellipsis;
    word-wrap: break-word;
  }
`;

interface RightAside {
  Open: boolean;
}

export const ContainerRightAside = styled.div<RightAside>`
  width: ${(props) => (props.Open ? "70%" : 0)};
  height: 100vh;
  max-width: 530px;
  position: fixed;
  background-color: #17100e;
  top: 0;
  right: 0;
  z-index: 79;
  transition-property: width;
  transition-duration: 0.2s;
  transition-timing-function: linear;
  transition-delay: 0s;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ContainerLeftAside = styled.div<RightAside>`
  width: ${(props) => (props.Open ? "70%" : 0)};
  height: 100vh;
  position: fixed;
  background-color: #fcfcfc;
  z-index: 79;
  top: 0;
  left: 0;
  transition-property: width;
  transition-duration: 0.2s;
  transition-timing-function: linear;
  transition-delay: 0s;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
